// src/utils/authTest.js
import { authenticatedGet } from "./apiUtils";

/**
 * Test function to verify authentication is working
 * This can be called from browser console to test the fix
 */
export const testAuthentication = async () => {
  console.log("🧪 Testing authentication...");

  try {
    console.log("📡 Making test API call to /assets...");
    const response = await authenticatedGet("/assets");

    if (response.ok) {
      const data = await response.json();
      console.log("✅ Authentication test PASSED!");
      console.log(`📊 Found ${data.length} assets`);
      return { success: true, data };
    } else {
      console.log("❌ Authentication test FAILED - Response not OK");
      return { success: false, error: `Status: ${response.status}` };
    }
  } catch (error) {
    console.log("❌ Authentication test FAILED - Exception thrown");
    console.error("Error:", error);
    return { success: false, error: error.message };
  }
};

// Make it available globally for testing
window.testAuth = testAuthentication;
